<script>
import { mapState, mapActions } from 'vuex';
/* components */
import Button from '@/components/Button';
/* tools */
import routes from '@/scripts/constants/home-menu';
import { applyLanguage } from '@/scripts/language';
import { signOut } from '@/scripts/api/account';
import { clearAll } from '@/scripts/utils/store-dependent';
import { wsConnection } from '@/scripts/modules/ws';
import { isFunction } from '@/scripts/utils';

export default {
  name: 'HomeMenu',
  components: {
    Button,
    /* Language, */
  },
  props: {
    test: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.routes = routes;
  },
  mounted() {},
  methods: {
    ...mapActions({}),
    applyLanguage,
    signOut() {
      signOut()
        .then(() => {
          if (wsConnection && isFunction(wsConnection.reset)) {
            wsConnection.reset();
          }

          clearAll();
        })
        .catch(() => {
          localStorage.removeItem('token');
          window.location.reload();
        });
    },
  },
};
</script>

<template>
  <div class="menu">
    <div class="menu__top">
      <div class="menu__left">
        <!-- TODO: next release -->
        <!-- <div class="menu__collapse" @click="isActive = !isActive">
          <img
            :src="
              require(`@/assets/svg/menu/dot${isActive ? '-active' : ''}.svg`)
            "
          />
        </div> -->
        <div class="menu__logo">
          <img :src="require('@/assets/svg/menu/header.svg')" />
        </div>
      </div>
      <div class="menu__right">
        <div class="menu__line-item menu__line-item--lang">
          <!-- TODO: next release -->
          <!-- <language/> -->
        </div>
        <div class="menu__line-item menu__line-item--leaderboard" v-if="!user">
          <Button to="/leaderboard" class="link actiive">
            <img
              :src="require('@/assets/svg/leaderbaord-yellow.svg')"
              class="img-icon img-icon--lg"
            />
            Leaderboard
          </Button>
        </div>
        <div class="menu__line-item">
          <Button to="/login" class="link actiive" v-if="!user">
            Login
          </Button>
          <Button
            to="/dashboard"
            class="icon actiive dash default hide-mobile"
            v-else
          >
            <img
              :src="require('@/assets/svg/statistics.svg')"
              class="img-icon"
            />
            Dashboard
          </Button>
        </div>
        <div
          :class="{ 'menu__line-item': true, 'menu__line-item--user': user }"
        >
          <!--  -->
          <Button
            v-if="user"
            @click="signOut"
            class="icon actiive logout hide-mobile"
          >
            <img :src="require('@/assets/svg/logout.svg')" />
            Logout
          </Button>

          <!--  -->
          <Button v-else to="/sign-up" class="button default orange sm actiive">
            Sign Up
          </Button>
        </div>
      </div>
    </div>
    <div class="menu__bottom" v-show="isActive">
      <div class="menu__list">
        <!-- map> -->
        <div
          v-for="{ name, id, path } in routes"
          :class="[
            {
              menu__item: true,
              'is-active': $route.name === name,
            },
            'menu__item--' + id,
          ]"
          :key="name"
        >
          <router-link :to="path" class="link-route actiive">
            <div class="link-route__title">{{ applyLanguage(id) }}</div>
          </router-link>
          <div class="menu__img"></div>
        </div>
        <!-- <map -->
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.menu {
  width: 100%;
  padding: 40px 0;
  background: transparent;
  position: sticky;
  top: 0;
  z-index: 10;
  pointer-events: none;

  &__top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 40px;
    position: relative;
    z-index: 2;
  }

  &__left {
    display: flex;
    align-items: center;
  }

  &__collapse {
    display: flex;
    align-items: center;
    width: 25px;
    height: 24px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      opacity: 0.7;
    }

    img {
      display: flex;
      width: 25px;
      height: 24px;
    }
  }

  &__right {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  &__line-item {
    & + & {
      margin-left: 40px;
    }

    & + &--user {
      margin-left: 20px;
    }

    &--lang + & {
      margin-left: 50px;
    }

    &--leaderboard {
      position: relative;
      padding-right: 40px;

      &:before {
        content: '';
        width: 1px;
        height: 25px;
        background: #ffc107;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        opacity: 0.7;
      }
    }
  }

  &__bottom {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    padding-left: 135px;
    z-index: 1;
    background: #0e0e0e;
  }

  &__list {
    height: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    padding-top: 40px;
    padding-bottom: 150px;
  }

  &__logo {
    display: none;
  }

  &__item {
    display: flex;

    &:hover,
    &.is-active {
      .link-route {
        color: #ffc107;
      }
    }

    & + & {
      margin-top: 40px;
    }

    &--about {
      .menu__img {
        background-image: url('~@/assets/png/menu/bg-about.png');

        &:after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background-image: url('~@/assets/svg/menu/logo.svg');
          width: 513px;
          height: 50px;
          background-size: cover;
        }
      }

      &.is-active,
      &:hover {
        .menu__img {
          opacity: 1;
          visibility: visible;
        }
      }
    }

    &--referrals {
      .menu__img {
        background-image: url('~@/assets/png/menu/bg-referrals.png');
      }

      &.is-active,
      &:hover {
        .menu__img {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }

  &__img {
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 58%;
    background-position: right;
    background-size: cover;
    opacity: 0;
    visibility: hidden;
    transition: all 0.4s;
    min-width: 780px;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      opacity: 0.5;
      background-image: radial-gradient(
        circle at 51% 50%,
        rgba(14, 14, 14, 0.03),
        #0e0e0e 81%
      );
      z-index: 1;
    }
  }
}

.actiive {
  pointer-events: auto;
}

.link-route {
  font-family: Sen-Bold;
  font-size: 60px;
  line-height: 72px;
  color: rgba(255, 255, 255, 0.2);
  transition: all 0.2s;
  text-decoration: none;
  text-transform: uppercase;
  position: relative;
  z-index: 2;
}

.img-icon {
  width: 14px;
  height: 16px;
  display: flex;
  margin-right: 10px;

  &.img-icon--lg {
    width: 16px;
  }
}

@media (max-width: $mobile) {
  .menu {
    padding: 17px 0;
    position: fixed;
    background-image: linear-gradient(to bottom, #0b0b0b, rgba(11, 11, 11, 0));

    &__logo {
      display: flex;

      img {
        display: flex;
        width: 40px;
        height: 35px;
      }
    }
    &__top {
      padding: 0 20px;
    }

    .menu__line-item--lang + .menu__line-item {
      margin-left: 0;
    }

    .menu__line-item + .menu__line-item {
      margin-left: 25px;
    }

    .menu__line-item--leaderboard {
      display: none;
    }
  }
}
</style>
